<template>
    <el-dialog
        :visible.sync="show"
        :before-close="handleClose"
        title="症状量表"
        width="900px"
        class="clinical-picture"
        >
        <div class="dialog-cont" >
            <el-form>
                <div class="cont flex">
                    <div class="cont-nav">
                        <div class="nav-list">
                             <ul >
                                <li :class="item.num==activeIndex?'active':''" v-for="(item,index) in navTab" :key="index" @click="tab_click(item)">{{item.value}}</li>
                            </ul>
                        </div>
                    </div>
                    
                    <div class="cont-info">
                        <div class="info">
                            <el-form-item v-for="(item, index) in listData[activeVlaue]" :key="index" :label='item.name+"："' :label-width="labelWidth">
                                <el-radio-group v-removeAriaHidden v-model="item.title">
                                    <el-radio v-for="(radio,num) in radioType" :key="num" :label='radio.value'></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        
                    </div>
                </div>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveClinical" >保存</el-button >
        </div>
    </el-dialog>
</template>

<script>
import layerList from "../../utils/jiahao.js";
export default {
    props: ['show'],
    data () {
        return {
            isDisplay:false,
            labelWidth:'200px',
            radioType:[
                {value:'无',label:'无'},
                {value:'轻',label:'轻'},
                {value:'中',label:'中'},
                {value:'重',label:'重'},
            ],

            activeVlaue:'toujingList',
            activeIndex:1,
            navTab:[
                {value:'头颈及五官',num:1,label:'toujingList'},
                {value:'胸腹',num:2,label:'xiongfuList'},
                {value:'四肢腰背',num:3,label:'sizhiyaobeiList'},
                {value:'寒热',num:4,label:'hanreList'},
                {value:'汗出',num:5,label:'hanchuList'},
                {value:'皮肤',num:6,label:'pifuList'},
                {value:'男女生殖',num:7,label:'nannvshengzhiList'},
                {value:'二便',num:8,label:'erbianList'},
                {value:'全身不适',num:9,label:'quanshenbushiList'},
            ],
            listData:{
                toujingList: layerList.toujinglists,
                xiongfuList: layerList.xiongfu,
                sizhiyaobeiList: layerList.sizhiyaobei,
                hanreList: layerList.hanre,
                hanchuList: layerList.hanchu,
                pifuList: layerList.pifu,
                nannvshengzhiList: layerList.nannvshengzhi,
                erbianList: layerList.erbian,
                quanshenbushiList: layerList.quanshenbushi,
            },

            
        }
    },
    mounted () {
    },
    methods: {
        tab_click(item){
            this.activeIndex=item.num;
            this.activeVlaue = item.label;
        
        },
        saveClinical(){
            let newArr=[];
            for(const key in this.listData){
                this.listData[key].forEach(item=>{
                    if(item.title){
                        let obj={
                            name:item.name,
                            title:item.title
                        }
                        newArr.push(obj)
                    }
                })
            }
            this.$emit('save',newArr)
        },
        clearTitle(){
            for(const key in this.listData){
                this.listData[key].forEach(item=>{
                    item.title=''
                })
            }
        },
        handleClose(){
            this.$emit('update:show',false)
        }
    }
}
</script>
